import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-5xl font-bold text-center mb-12 text-gray-800">Dashboard</h1>
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
        <div className="flex items-center mb-8">
          <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white text-3xl font-bold">
            {user?.name?.charAt(0) || 'S'}
          </div>
          <div className="ml-6">
            <h2 className="text-2xl font-bold">{user?.name || 'Student'}</h2>
            <p className="text-gray-600">{user?.email || 'student@studentencity.nl'}</p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-blue-50 p-6 rounded-xl">
            <div className="text-3xl font-bold text-blue-600">12</div>
            <div className="text-gray-600">Events bekeken</div>
          </div>
          <div className="bg-purple-50 p-6 rounded-xl">
            <div className="text-3xl font-bold text-purple-600">3</div>
            <div className="text-gray-600">Kortingen gebruikt</div>
          </div>
          <div className="bg-green-50 p-6 rounded-xl">
            <div className="text-3xl font-bold text-green-600">5</div>
            <div className="text-gray-600">Kamers bekeken</div>
          </div>
        </div>
      </div>
    </div>
  );
}
